import { Grid } from "@mui/material";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { getPermissions } from "../../commonFunctions/PermissionManger";
import {
  getLocalValue,
  IRoleMain,
  LoacalVariables,
  MasterPages,
} from "../../commonFunctions/CommonFunctions";
import WSDataGrid, { IColumns } from "../../Components/DataGrid/WSDataGrid";
import { HeaderList } from "../../Components/Header/HeaderList";
import PermissionDenied from "../../commonFunctions/PermissionDenied";
import { resetDataComponent } from "../../StateManagement/actions";
import { useDispatch } from "react-redux";
import { useSnackbar } from "../../Components/Snackbar/SnackBarContext";
import ConfirmationPopup from "../../Components/Confirmation/Confirmation";

export const RiderList: React.FC<any> = React.memo((props) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { showMessage } = useSnackbar();
  const { edit, add, view, exports } = getPermissions(
    MasterPages.Services,
    IRoleMain.Masters
  );

  const [totalCount, setTotalCount] = useState<any>();
  const [selectedId, setSelectedId] = useState<any>(null);
  const [isPopupOpen, setPopupOpen] = useState(false);

  const source = {
    url: "riders/search",
    page: 1,
    pageSize: 10,
    filter: [
      {
              field: "FranchiseId",
              operator: "eq",
              value: getLocalValue(LoacalVariables.FranchiseId)
            }
    ],
    sort: []
  };

  /**
   *  Edit function
   * @param action
   * @param row
   */
  const handleAction = (action: string, row: any) => {
    if (action === "Edit") {
      navigate(`/rider/${row?.id}`);
    } else if (action === "Delete") {
      setPopupOpen(true);
      setSelectedId(row?.id);
    }
  };

  const handleDelete = (response: any) => {
    dispatch(resetDataComponent("riderGrid"));
    showMessage("Rider deleted successfully!", "success");
  };

  const columns: IColumns[] = [
    {
      header: "Rider Name",
      fieldName: "fullName",
      type: "default"
    },

    {
      header: "Phone Number",
      fieldName: "phoneNumber",
      type: "default"
    },

    {
      header: "Vehicle Number",
      fieldName: "vehicleNumber",
      type: "default"
    },

    {
      header: "Status",
      fieldName: "status",
      type: "status"
    },
    {
      header: "Actions",
      fieldName: "actions",
      type: "action",
      actions: [edit ? "Edit" : undefined, "Delete"],
      actionCallback: (action, row) => handleAction(action, row)
    }
  ];

  const handleClick = () => {
    navigate("/rider");
  };
  const transFormData = (data: any, totalCount: any) => {
    setTotalCount(totalCount);
    return data;
  };
  return (
    <>
      <HeaderList
        title="Riders"
        type="card"
        info={`${totalCount || 0} Total Records`}
      />
      {view ? (
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <WSDataGrid
              id="riderGrid"
              title="Riders"
              columns={columns}
              headerType="HaderTopCornered"
              source={source}
              exportCsv={exports}
              addButton={add ? { label: "", color: "secondary" } : undefined}
              onAddButtonClick={handleClick}
              transFormData={transFormData}
              searchBox={{
                fieldName: "vehicleNumber",
                bg: "white"
              }}
              placeholder={"Search by Vehicle Number"}
            />
          </Grid>
        </Grid>
      ) : (
        <PermissionDenied />
      )}

      {selectedId !== null && (
        <ConfirmationPopup
          apiUrl={"riders"}
          id={selectedId}
          confirmMessage="Are you sure you want to delete this rider?"
          open={isPopupOpen}
          onClose={() => setPopupOpen(false)}
          onConfirm={handleDelete}
          permanent
        />
      )}
    </>
  );
});
